












import BaseComponent from '@/components/base-component.vue';
import ListMessages from '@/components/UI/list-messages.vue';
import StringUtils from '@/helpers/stringUtils';
import Component from 'vue-class-component';
import { GChart } from 'vue-google-charts/legacy';
import { Prop, Watch } from 'vue-property-decorator';

@Component({
  components: {
    GChart,
    ListMessages
  }
})
export default class AdmsVisitorsCharts extends BaseComponent {
  @Prop()
  admKpis: any;

  @Prop()
  keyValue: number;

  chartData: any[] = [];

  chartOptions = {
    backgroundColor: 'transparent',
    chartArea: { left: '200', top: '0', right: '20', bottom: '50' },
    legend: { position: 'bottom' },
    isStacked: true,
    //colors: ['102D69', 'F5B830'],
    fontSize: 12
  };

  mounted() {
    this.load();
  }

  load() {
    this.chartData = [];
    let cat: Array<any> = ['Usuário'];
    if (!this.admKpis || !this.admKpis.tipos) {
      return;
    }

    this.admKpis.tipos.forEach((tp) => {
      cat.push(tp.nome);
      cat.push({ role: 'annotation' });
    });
    this.chartData.push(cat);

    this.admKpis.dados.forEach((u) => {
      let nmUser = `${StringUtils.abbreviate(u.nome, 25)}`;
      let list: Array<any> = u.lista;

      let data: Array<any> = [nmUser];
      this.admKpis.tipos.forEach((tp) => {
        let vTp = list.find((i) => i.id == tp.id);
        let v = !!vTp ? Math.ceil((vTp.valor / 60) * 10) / 10 : 0;
        data.push(v);
        data.push(v);
      });

      this.chartData.push(data);
    });
  }

  @Watch('admKpis', { immediate: true })
  admKpisWatch(v) {
    if (!v) {
      return;
    }
    this.load();
  }
}
